import _ from 'lodash';
import { TableCell, Typography } from '@mui/material';

export interface BakeasyTableCellProps {
  style?: any;
  value?: any;
  colSpan?: any;
}

export function BakeasyTableCell(props: BakeasyTableCellProps) {
  return (
    <TableCell
      colSpan={props?.colSpan ? props?.colSpan : 0}
      sx={props?.style === undefined ? { pt: 1, pb: 1 } : props?.style}
    >
      <Typography sx={{ fontWeight: 'bold', fontSize: '0.95rem', textAlign: 'right' }}>
        {props?.value}
      </Typography>
    </TableCell>
  );
}
